'use client';
import { createStyles, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var typographyVariation = {
    sizes: {
        xs1: [
            12,
            16
        ],
        sm1: [
            14,
            20
        ],
        md1: [
            14,
            20
        ]
    }
};
var useStyles = createStyles(function(theme, param, param1) {
    var required = param.required;
    var size = param1.size;
    var requiredStyle = required ? {
        "&::after": {
            content: '"*"',
            position: "relative",
            left: "4px",
            color: theme.palette.disruption.base,
            fontWeight: theme.typography.default.weights.semibold
        }
    } : {};
    return {
        label: _extends({
            padding: rem("0 2"),
            display: "flex",
            justifyContent: "space-between",
            position: "relative"
        }, theme.fn.typography({
            size: size,
            variant: typographyVariation,
            color: theme.palette.text.medium
        })),
        labelText: requiredStyle,
        labelIcon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    };
});

export { useStyles as default };
